<script setup>
import { ref, toRefs, onBeforeMount } from 'vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'
import BackButton from '@/src/vueComponent/BackButton.vue'
import { SendOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  token: {
    type: String
  },
  permissionInfo: {
    type: Object
  },
  permissionItem: {
    type: Array
  }
})

const { token, permissionInfo, permissionItem } = toRefs(props)
import BaseRadio from '@/src/vueComponent/BaseRadio.vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseCheckbox from '@/src/vueComponent/BaseCheckbox.vue'

const i18n = I18n
const editPermissinonInfo = ref({})

onBeforeMount(() => {
  if (permissionInfo.value.id === null) {
    editPermissinonInfo.value = {
      ...permissionInfo.value,
      content: permissionItem.value.reduce((acc, item) => {
        const { module, actions } = item
        acc[module] = {}
        actions.forEach((action) => {
          acc[module][action] = null
        })
        return acc
      }, {})
    }
  } else {
    const updatedContent = permissionItem.value.reduce((acc, item) => {
      const { module, actions } = item
      acc[module] = permissionInfo.value.content[module] || {}
      actions.forEach((action) => {
        acc[module][action] = acc[module][action] !== undefined ? acc[module][action] : null
      })
      return acc
    }, {})

    editPermissinonInfo.value = {
      ...permissionInfo.value,
      content: updatedContent
    }
  }
})

const checkedPermissionItemAction = (event, moduleName, actionName) => {
  editPermissinonInfo.value.content[moduleName][actionName] =
    editPermissinonInfo.value.content[moduleName][actionName] === event ? null : event
}

const submitForm = () => {
  $.ajax({
    url: editPermissinonInfo.value.id
      ? `/settings/permissions/${editPermissinonInfo.value.id}`
      : '/settings/permissions',
    type: editPermissinonInfo.value.id ? 'PATCH' : 'POST',
    dataType: 'json',
    headers: { 'X-CSRF-Token': token.value },
    authenticity_token: true,
    data: editPermissinonInfo.value,
    success: async (response) => {
      if (response.state === 0) {
        window.location.replace('/settings/permissions')
      }
    },
    error: async (error) => {
      console.log('error', error)

      if (error.responseJSON.state === -1) {
        await mySwal.error({
          title: error.responseJSON.message.join('<br />'),
          timer: 3000
        })

        if (error.responseJSON.redirect_to) {
          window.location.replace(error.responseJSON.redirect_to)
        }
      }
    }
  })
}
</script>
<template>
  <form @submit.prevent="submitForm" class="leave-need-confirm">
    <div class="mb-3 grid grid-cols-2 gap-3">
      <div>
        <p class="flex items-baseline gap-1 py-1 text-lg font-bold">
          <span>狀態</span>
          <span class="text-sm font-light text-red-400">*</span>
        </p>
        <div class="mb-4 flex gap-3">
          <BaseRadio
            :label="'啟用'"
            :name="'state'"
            :value="'enable'"
            v-model="editPermissinonInfo.state"
            required
          />
          <BaseRadio
            :label="'停用'"
            :name="'state'"
            :value="'disable'"
            v-model="editPermissinonInfo.state"
            required
          />
        </div>
      </div>
      <div>
        <BaseTextInput
          :label="'群組名稱'"
          :name="'account'"
          v-model="editPermissinonInfo.name"
          required
        />
      </div>
    </div>
    <div class="mb-4 grid grid-cols-4 rounded-md border border-gray-200 xl:grid-cols-2">
      <div
        v-for="(itemValue, itemKey) in editPermissinonInfo.content"
        :key="itemKey"
        class="rounded-none border border-l-0 border-t-0 border-gray-200 p-4"
      >
        <label class="mb-2 block text-lg font-bold">
          {{ i18n.t(`perm_module.${itemKey}`) }}
        </label>
        <div class="grid grid-cols-4 gap-2">
          <div v-for="(actionValue, actionKey) in itemValue" :key="actionKey">
            <BaseCheckbox
              :name="`content[${itemKey}][${actionKey}]`"
              :value="1"
              :label="i18n.t(`perm_action.${actionKey}`)"
              :modelValue="Number(actionValue)"
              @update:modelValue="checkedPermissionItemAction($event, itemKey, actionKey)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 py-3">
      <BackButton :hasForm="true" :returnPath="'/settings/permissions'" />
      <button type="submit" class="btn btn-success text-xl text-white">
        <SendOutlined />
        送出
      </button>
    </div>
  </form>
</template>
